import { Region } from './enum/region.enum';
import { AmplifyConfig } from './interfaces/amplify-config.interface';

export const amplifyConfigProdEu: AmplifyConfig = {
  Auth: {
    identityPoolId: 'eu-central-1:99b127b9-e36f-4579-8a7d-8adf20b0305f',
    region: Region.EU,
    userPoolId: 'eu-central-1_WLn0stHoQ',
    userPoolWebClientId: 'm4sjpf6ei6485ihgfv9k4qat1',
    authenticationFlowType: 'CUSTOM_AUTH',
    oauth: {
      domain: 'paveapp.auth.eu-central-1.amazoncognito.com',
      scope: ['phone', 'email', 'openid', 'aws.cognito.signin.user.admin'],
      redirectSignIn: 'https://dashboard.pavecommute.app',
      redirectSignOut: 'https://dashboard.pavecommute.app',
      responseType: 'code',
    },
  },
  Storage: {
    customPrefix: { public: '', protected: '', private: '' },
    AWSS3: {
      bucket: 'ra-eu-pave-prod-private', // REQUIRED -  Amazon S3 bucket name
      region: Region.EU, // OPTIONAL -  Amazon service region,
    },
  },
};
